const isDefaultLogo = source => !source || [
  'images/npos/logos/default/heart_hands.svg',
  'images/npos/logos/default/default_logo.svg',
  'images/npos/logos/default/logo.jpg',
].indexOf(source) > -1

export default isDefaultLogo
